const localization = {
    cannot_delete_default_language: '{{languageTag}} é o seu idioma padrão e não pode ser excluído.',
    invalid_translation_structure: 'Estrutura de dados inválida. Verifique sua entrada e tente novamente.',
};
export default Object.freeze(localization);
